var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section-posts2 section-posts-planner-view" },
    [
      _c(
        "div",
        { staticClass: "navigations" },
        [
          _c("div", { staticClass: "navigation-date" }, [
            _c(
              "div",
              {
                staticClass: "btn-radius",
                on: {
                  mouseenter: function ($event) {
                    _vm.eventIsDrag && _vm.goToToday()
                  },
                  click: _vm.goToToday,
                },
              },
              [_vm._v(_vm._s(_vm.$t("dash.posts.nav.today")))]
            ),
            _c(
              "div",
              {
                staticClass: "btn-radius icon",
                on: {
                  mouseenter: function ($event) {
                    _vm.eventIsDrag && _vm.prev()
                  },
                  click: _vm.prev,
                },
              },
              [_c("i", { staticClass: "fa-solid fa-chevron-left" })]
            ),
            _c(
              "div",
              {
                staticClass: "btn-radius icon",
                on: {
                  mouseenter: function ($event) {
                    _vm.eventIsDrag && _vm.next()
                  },
                  click: _vm.next,
                },
              },
              [_c("i", { staticClass: "fa-solid fa-chevron-right" })]
            ),
            _c("div", { staticClass: "date" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.models.date,
                    expression: "models.date",
                  },
                ],
                attrs: { type: "date", lang: _vm.$i18n.locale || "fr-FR" },
                domProps: { value: _vm.models.date },
                on: {
                  click: (e) => e.target.showPicker(),
                  change: _vm.setDateFromDatePiker,
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.models, "date", $event.target.value)
                  },
                },
              }),
              _c("h4", [_vm._v(_vm._s(_vm.dateFormat))]),
              _c("i", { staticClass: "fa-solid fa-caret-down" }),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "navigation-filter" },
            [
              _c(
                "div",
                {
                  staticClass: "btn-radius filter",
                  attrs: { "data-count": _vm.filterCount },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.filterIsOpen = true
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("dash.posts.list.filter")) +
                      "\n                "
                  ),
                  _vm.filterIsOpen
                    ? _c("FilterNavigation", {
                        attrs: { filter: _vm.filter },
                        on: {
                          close: function ($event) {
                            _vm.filterIsOpen = false
                          },
                          "update:filter": function ($event) {
                            _vm.filter = $event
                          },
                          updateCalendar: _vm.refreshEvents,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "ContextMenu",
                {
                  attrs: {
                    options: _vm.contextMenuOptions,
                    id: "ContextMenuPlanner",
                  },
                  on: { clickOption: _vm.clickOption },
                },
                [
                  _c("div", { staticClass: "btn-radius icon" }, [
                    _c("i", { staticClass: "fa-solid fa-ellipsis-vertical" }),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "btn-radius icon",
                  on: {
                    click: function ($event) {
                      return _vm.getPlannerData(0)
                    },
                  },
                },
                [_c("i", { staticClass: "fa-solid fa-rotate-right" })]
              ),
            ],
            1
          ),
          _c(
            "MainNavigation",
            _vm._g(
              {
                attrs: {
                  tabSelected: _vm.tabSelected,
                  currentViewType: _vm.currentViewType,
                },
                on: { switchCurrentViewType: _vm.switchCurrentViewType },
              },
              _vm.$listeners
            )
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "planner", class: [_vm.currentViewType] },
        [
          _vm.isLoading
            ? _c("div", { staticClass: "loading-overlay" }, [
                _c("i", { staticClass: "fa-sharp fa-solid fa-spinner-third" }),
                _vm._v(_vm._s(_vm.$t("dash.posts.list.loading"))),
              ])
            : _vm._e(),
          _c("Calendar", {
            ref: "calendar",
            attrs: { initialEvent: Object.values(_vm.events) },
            on: {
              eventDragStart: _vm.handleDragStart,
              eventDragStop: _vm.handleDragStop,
              selectDate: _vm.handleDateSelect,
              eventClick: _vm.handleEventClick,
            },
          }),
        ],
        1
      ),
      _vm.eventIsDrag
        ? [
            _c("div", {
              staticClass: "prevMonthHover",
              on: { mouseenter: _vm.prev },
            }),
            _c("div", {
              staticClass: "nextMonthHover",
              on: { mouseenter: _vm.next },
            }),
          ]
        : _vm._e(),
      _vm.eventIdSelected
        ? _c("DrawerPost", {
            ref: "drawerPost",
            attrs: { event: _vm.events[_vm.eventIdSelected] },
            on: { close: _vm.closeDrawer, deletePost: _vm.handlerDeletePost },
          })
        : _vm._e(),
      _vm.displaySharedPlanner
        ? _c("SharedPlanner", {
            attrs: { display: _vm.displaySharedPlanner },
            on: {
              close: function ($event) {
                _vm.displaySharedPlanner = false
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }